export const searchSelection = {
  attrs: {
    class: { default: 'searchSelection' }
  },
  parseDOM: [{ tag: `span.searchSelection` }],
  toDOM: function (mark) {
    return ['span', mark.attrs]
  }
}
